import { render, staticRenderFns } from "./ObstetricsAssessment.vue?vue&type=template&id=b5d06a68&scoped=true"
import script from "./ObstetricsAssessment.vue?vue&type=script&lang=js"
export * from "./ObstetricsAssessment.vue?vue&type=script&lang=js"
import style0 from "./ObstetricsAssessment.vue?vue&type=style&index=0&id=b5d06a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d06a68",
  null
  
)

export default component.exports